<template>
    <div class="gpt-shortcuts">
        <div class="gpt-shortcuts__open" @click="changeShortcutsStatus(true)" v-show="!shortcutsShow">
            <div class="gpt-shortcuts__open-img"></div>
        </div>
        <div class="gpt-shortcuts__content" v-show="shortcutsShow">
            <div class="shortcutsItem" @click="toMemFrontend">
                <div class="img img-tool"></div>
                <label>控制台</label>
            </div>
            <div v-if="!isCall" class="shortcutsItem" @click="showModelList('通用模型')">
                <div class="img img-knowledge"></div>
                <label>通用模型</label>
            </div>
            <div v-else class="shortcutsItem" @click="showAssistantDialog()">
                <div class="img img-knowledge"></div>
                <label>应用模型</label>
            </div>
            <div class="shortcutsItem" @click="ui.human.show = !ui.human.show">
                <div class="img img-ai"></div>
                <label>数字人</label>
            </div>
            <div class="shortcutsItem" @click="toPictureDemo">
                <div class="img"></div>
                <label>视觉模型</label>
            </div>
            <div class="gpt-shortcuts__close" @click="changeShortcutsStatus(false)">
                <div class="gpt-shortcuts__close-img"></div>
            </div>
            <gpt-digital-human v-show="ui.human.show" ref="human"
            :video="HUMAN[ui.human.idx].video" :standbyRange="HUMAN[ui.human.idx].standbyRange" :speekRange="HUMAN[ui.human.idx].speekRange" :voiceType="HUMAN[ui.human.idx].voiceType"
            @click.native="ui.human.idx++; ui.human.idx > HUMAN.length - 1 ? ui.human.idx = 0 : ui.human.idx"
            @speek="speekCallback"
            @standby="standbyCallback" />
        </div>
        <gpt-dialog-ai-model :visible.sync="ui.modelList.show" :category="ui.modelList.category" @showModelSetting="showModelSetting"></gpt-dialog-ai-model>
        <ModelSettingDrawer ref="modelSettingDrawer" @changeModelSetting="$emit('changeModelSetting')"></ModelSettingDrawer>
        <assistantDialog ref="assistantDialog" @assistantChat="$emit('assistantChat', $event)"/>
    </div>
</template>

<script>
import HUMAN from '@/app/constant/HUMAN.js';
import ModelSettingDrawer from '../ui/ModelSettingDrawer.vue';
import assistantDialog from '../ui/_MemFrontendPage/assistant-dialog.vue';
export default {
    name: 'gpt-shortcuts',
    components: { ModelSettingDrawer, assistantDialog },
    props: {
        isCall: {
            type: Boolean,
            default: true
        }
    },
    data () {
        let ui = {
            human: {
                idx: 1,
                show: false
            },
            modelList: {
                show: false,
                category: null
            }
        };
        return {
            ui,
            HUMAN,
            username: '',
            shortcutsShow: false
        };
    },
    mounted () {
        this.username = this.$store.state.account.username;
        this.$bus.$on('openAiModel', (category) => {
            this.showModelList(category);
        });

        this.initHumanEvents();
    },
    methods: {
        toPictureDemo () {
            this.$emit('toPictureDemo');
        },
        // 展示中间件应用列表
        showAssistantDialog () {
            this.$refs.assistantDialog.showDialog();
        },
        toMemFrontend () {
            let memFrontendUrl = this.$store.state.account.globalConfigs.IMPORT_CONFIGS.memFrontendUrl;
            if (memFrontendUrl) {
                memFrontendUrl += this.$store.state.account.token;
                // 带上token信息重定向到中间件页面
                window.open(memFrontendUrl);
            } else {
                this.$message.warning('未配置页面信息');
            }
        },
        goto (path) {
            this.$router.push(path);
        },
        showModelList (category) {
            this.shortcutsShow = true;
            this.ui.modelList.category = category;
            this.ui.modelList.show = true;
        },
        changeShortcutsStatus (status) {
            this.shortcutsShow = status;
        },
        initHumanEvents () {
            // 对接$bus
            if (typeof this.$bus !== 'undefined') {
                // 显示/隐藏数字人
                this.$bus.$on('digital-human:show', (data) => {
                    this.ui.human.show = data && data.show;
                    if (this.ui.human.show) this.shortcutsShow = true;
                });
                // 切换数字人
                this.$bus.$on('digital-human:toggle', (data) => {
                    this.ui.human.show = !this.ui.human.show;
                    if (this.ui.human.show) this.shortcutsShow = true;
                });
                // 传入文字，语音播报
                this.$bus.$on('digital-human:speek-text', (data) => {
                    this.shortcutsShow = true;
                    this.ui.human.show = true;
                    let human = this.$refs.human;
                    try {
                        human.speekText(data.text);
                    } catch (e) {
                        console.debug('思必驰语音模式异常，或到期');
                    }
                });

                // 播报动作
                this.$bus.$on('digital-human:speek', (data) => {
                    this.shortcutsShow = true;
                    this.ui.human.show = true;
                    let human = this.$refs.human;
                    try {
                        human.speek();
                    } catch (e) {
                        console.debug('思必驰语音模式异常，或到期');
                    }
                });

                // 待机动作
                this.$bus.$on('digital-human:standby', (data) => {
                    let human = this.$refs.human;
                    try {
                        human.standby();
                    } catch (e) {
                        console.debug('思必驰语音模式异常，或到期');
                    }
                });
            } else {
                console.warn('$bus undefined.');
            }
        },
        showModelSetting (item) {
            this.$refs.modelSettingDrawer.open(item);
        },

        speekCallback () {
            this.$bus.$emit('digital-human:speek-callback');
        },

        standbyCallback () {
            this.$bus.$emit('digital-human:standby-callback');
        }
    }
};
</script>

<style scoped lang="scss">
.gpt-shortcuts {
    position: fixed;
    right: 0;
    height: 100%;
    display: flex;
    pointer-events: none;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    // transform: translateY(-50%);
    z-index: 2;

    .gpt-shortcuts__content {
        position: relative;
        width: 72px;
        padding: 0 8px;
        margin-right: 16px;
        background: var(--shortcuts);
        box-shadow: var(--shortcuts-box-shadow);
        border-radius: 4px;
        pointer-events: auto;
    }

    .gpt-shortcuts__open {
        position: relative;
        right: 0;
        cursor: pointer;
        pointer-events: auto;

        .gpt-shortcuts__open-img {
            width: 20px;
            height: 80px;
            background-image: var(--shortcuts-open-img);
            background-size: contain;
            background-repeat: no-repeat;

        }
    }

    .shortcutsItem {
        width: 100%;
        text-align: center;
        padding: 24px 0;
        border-bottom: 1px solid var(--shortcuts-border);
        cursor: pointer;

        .img {
            display: inline-block;
            margin-bottom: 4px;
            height: 24px;
        }
        .img-knowledge {
            width: 24px;
            background: var(--shortcuts-knowledge);
        }

        .img-ai {
            width: 30px;
            background-image: var(--shortcuts-al_model);
        }

         .img-tool {
            width: 24px;
            background-image: var(--shortcuts-tool);
        }

        &:nth-child(4) {
            .img {
                width: 24px;
                background-image: var(--shortcuts-picture);
            }
        }
        &:nth-last-child(3) {
            border-bottom: none;
            padding-bottom: 16px;
        }

        label {
            display: block;
            font-size: 14px;
            color: var(--shortcuts-font-color);
            line-height: 20px;
            cursor: pointer;
        }

        small {
            height: 18px;
            font-size: 12px;
            color: var(--shortcuts-font-color);
            line-height: 18px;
        }
    }

    .gpt-shortcuts__close {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-bottom: 12px;

        .gpt-shortcuts__close-img {
            width: 12px;
            height: 12px;
            background: var(--shortcuts-close-img) no-repeat;
        }
    }

    .gpt-digital-human {
        position: absolute;
        right: 88px;
        bottom: 0px;
        width: 250px;
        height: 300px;
        border-radius: 0.5em;
        overflow: hidden;
        box-shadow: 0 0 1em 0 rgba(0, 0, 0, 0.1);
    }
}
</style>
